// Dependencias

import React from 'react';
import './RespuestaNo.css';
import api from '../../../../api';

export default class RespuestaNo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        Id_Incidencia: props.RRespuesta?.resultado?.[1]?.[0]?.Id_Incidencia ||
          props.RRespuesta?.resultado?.[0]?.[0]?.Id_Incidencia || "",
        correo: props.RRespuesta?.cliente?.[1]?.[0]?.Email ||
          props.RRespuesta?.cliente?.[0]?.[0]?.Email || "",
        Obs_Incidencia: '',
        Cod_UsuarioAct: 'Web',
      },
      data: {
        resultado: []
      },
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  handleChange(e) {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  }

  async handleSubmit(e) {
    e.preventDefault();

    try {

      const Rincidencia = this.state.form.Id_Incidencia;
      const Robs_Incidencia = this.state.form.Obs_Incidencia;
      const Rcod_Usuario = this.state.form.Cod_UsuarioAct;
      const RCorreo = this.state.form.correo;


      const data = await api.IncidenciaCliente.guardarIncidenciaNoResuelta(Rincidencia, Robs_Incidencia, Rcod_Usuario)

      if (data.Exito === "1") {

        const mensaje = `<h2> Incidencia no resuelta </h2>
              <p> </p>
              <div style="text-align: justify;">
                <b>Nro Incidencia:</b> ${Rincidencia} 
              </div>
              <div style="text-align: justify;">
                <b>Comentario:</b>  
                <p>${Robs_Incidencia}</p>
              </div>
             `

        const emailEncuesta = await api.usuario.enviarCorreoEncuesta(RCorreo, Rincidencia, mensaje);

        if (emailEncuesta.Exito == "1") {
          alert("Mensaje enviado !")
          window.location.href = '/';
        }
        else {
          alert("no se pudo enviar el mensaje")
          window.location.href = '/';
        }

      }
      this.setState({
        data: { resultado: [].concat(this.state.data, data.resultado) }
      });
    } catch (error) {
      console.log('Error', error)

    }
  }

  render() {

    return (

      <div className="FormPreguntas">
        <div className="FormPreguntas__bloque1">
          <form onSubmit={this.props.onSubmit} >
            <div > {/* aqui codigo antiguo */}

              {/* observacion*/}
              <div className="pregunta-block">
                <p><b>1.Disculpe las molestias, por favor dejenos un comentario sobre el incoveniente:</b></p>
                <div className="pills-wrapper">
                  <textarea name="Obs_Incidencia" value={this.state.form.Obs_Incidencia || ''} onChange={this.handleChange}></textarea>
                </div>
              </div>
            </div>

          </form>

          <div className="pregunta-block-submit-container">
            <button
              type="submit"
              onClick={this.handleSubmit}
            >
              Enviar Encuesta
            </button>
          </div>
        </div>
      </div>
    );
  }
}



